import { render, staticRenderFns } from "./AddCampusComponent.vue?vue&type=template&id=4b98e397&"
import script from "./AddCampusComponent.vue?vue&type=script&lang=js&"
export * from "./AddCampusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports